'use strict';

const socketEventActions = {
  // Element State
  SOCKET_EVENT_ELEMENT_STATE_CHANGED_EVENT({ dispatch }, { interactionId, elementId, newElementStateId }) {
    const constraintNames = [newElementStateId];
    dispatch('removeEventTimingConstraint', { interactionId, constraintNames });
    dispatch('removeElementEventCallback', { elementId, eventName: 'ELEMENT_STATE_CHANGED_EVENT' });
  },

  // Interaction state
  SOCKET_EVENT_INTERACTION_STATE_CHANGED_EVENT({ dispatch }, { interactionId, interactionStateId }) {
    const constraintNames = [interactionStateId];
    dispatch('removeEventTimingConstraint', { interactionId, constraintNames });
  },

  // Interaction lifecycle
  SOCKET_EVENT_INTERACTION_ANSWERED_EVENT({ dispatch }, { interactionId }) {
    dispatch('clearEventTimingConstraint', { interactionId });
  },

  SOCKET_EVENT_INTERACTION_ACCEPTED_EVENT({ dispatch }, { interactionId }) {
    dispatch('clearEventTimingConstraint', { interactionId });
  },

  // TODO ContactList actions.
  // SOCKET_EVENT_INTERACTION_CREATED_OUTGOING_EVENT({ dispatch }, { interactionId }) {
  //   dispatch('clearEventTimingConstraint', { interactionId });
  // },

  SOCKET_EVENT_INTERACTION_REMOVED_FROM_AGENT_EVENT({ dispatch }, { interactionId }) {
    dispatch('clearEventTimingConstraint', { interactionId });
  },

  SOCKET_EVENT_SERVER_NOTIFICATION_EVENT({ dispatch }, { isError }) {
    if (isError) {
      dispatch('clearAllEventTimingConstraints');
    }
  },

  SOCKET_EVENT_INTERACTION_TRANSFERRED_EVENT({ dispatch }, { interactionId }) {
    dispatch('removeEventTimingConstraint', { interactionId, constraintNames: ['INTERACTION_TRANSFERRED_EVENT'] });
  },

  SOCKET_EVENT_INTERACTION_RECORDING_PAUSED_EVENT({ dispatch }, { interactionId }) {
    dispatch('removeEventTimingConstraint', { interactionId, constraintNames: ['INTERACTION_RECORDING_PAUSED_EVENT'] });
  },

  SOCKET_EVENT_INTERACTION_RECORDING_RESUMED_EVENT({ dispatch }, { interactionId }) {
    dispatch('removeEventTimingConstraint', {
      interactionId,
      constraintNames: ['INTERACTION_RECORDING_RESUMED_EVENT']
    });
  },

  SOCKET_EVENT_INTERACTION_RECORDING_BY_AGENT_STARTED_EVENT({ dispatch }, { interactionId }) {
    dispatch('removeEventTimingConstraint', {
      interactionId,
      constraintNames: ['INTERACTION_RECORDING_BY_AGENT_STARTED_EVENT']
    });
  },

  SOCKET_EVENT_INTERACTION_RECORDING_BY_AGENT_STOPPED_EVENT({ dispatch }, { interactionId }) {
    dispatch('removeEventTimingConstraint', {
      interactionId,
      constraintNames: ['INTERACTION_RECORDING_BY_AGENT_STOPPED_EVENT']
    });
  },

  SOCKET_EVENT_AGENT_STATE_CHANGED_EVENT({ dispatch }, { agentId }) {
    dispatch('removeEventTimingConstraintForAgentState', { agentId });
  },

  SOCKET_EVENT_COUNTER_UPDATE_EVENT({ dispatch }, event) {
    const MAX_TIME_TO_UPDATE_UI_COUNTER = 1000;
    setTimeout(() => dispatch('removeAllEventTimingConstraintsForKPICounters'), MAX_TIME_TO_UPDATE_UI_COUNTER);
  },

  SOCKET_EVENT_AGENT_TERMINAL_CHANGED_EVENT({ dispatch }, { agentId }) {
    dispatch('removeEventTimingConstraintForAgentTerminal', { agentId });
  },

  SOCKET_EVENT_INTERACTION_POSTPONED_EVENT({ dispatch, commit, rootGetters }, { interactionId }) {
    dispatch('removeEventTimingConstraint', { interactionId, constraintNames: ['INTERACTION_POSTPONED_EVENT'] });
  },

  SOCKET_EVENT_INTERACTION_OFFERED_TO_AGENT_EVENT({ dispatch, commit, rootGetters }, { interactionId }) {
    dispatch('removeEventTimingConstraint', { interactionId, constraintNames: ['INTERACTION_OFFERED_TO_AGENT_EVENT'] });
  }
};

const stateActions = {
  addEventTimingConstraint: ({ commit }, { interactionId, constraintNames }) => {
    commit('addConstraint', { interactionId, constraintNames });
  },

  removeEventTimingConstraint: ({ commit }, { interactionId, constraintNames }) => {
    commit('removeConstraint', { interactionId, constraintNames });
  },

  clearEventTimingConstraint: ({ commit }, { interactionId }) => {
    commit('clearConstraint', { interactionId });
  },

  clearAllEventTimingConstraints: ({ commit }) => {
    commit('clearAllConstraints');
  },

  // Custom events.

  addEventTimingConstraintForAgentState: ({ commit }, { agentId }) => {
    commit('addAgentStateConstraint', { agentId });
  },

  removeEventTimingConstraintForAgentState: ({ commit }, { agentId }) => {
    commit('removeEventTimingConstraintForAgentState', { agentId });
  },

  addEventTimingConstraintForAgentTerminal: ({ commit }, { agentId, timeout, timedOutAction }) => {
    commit('addAgentTerminalConstraint', { agentId, timeout, timedOutAction });
  },

  removeEventTimingConstraintForAgentTerminal: ({ commit }, { agentId }) => {
    commit('removeEventTimingConstraintForAgentTerminal', { agentId });
  },

  addEventTimingConstraintForKPICounter: ({ commit }, { counterTypeId, handlerId }) => {
    commit('addKPICounterConstraint', { counterTypeId, handlerId });
  },

  removeEventTimingConstraintForKPICounter: ({ commit }, { counterTypeId, handlerId }) => {
    commit('removeKPICounterConstraint', { counterTypeId, handlerId });
  },

  removeAllEventTimingConstraintsForKPICounters: ({ commit }) => {
    commit('removeAllEventTimingConstraints');
  },

  // Queued event callbacks

  queueInteractionEventCallback: ({ commit }, { interactionId, eventName, callback }) => {
    commit('queueInteractionEventCallback', { interactionId, eventName, callback });
  },

  queueElementEventCallback: ({ commit }, { elementId, eventName, callback }) => {
    commit('queueElementEventCallback', { elementId, eventName, callback });
  },

  removeInteractionEventCallback: ({ commit }, { interactionId, eventName }) => {
    commit('removeInteractionEventCallback', { interactionId, eventName });
  },

  removeElementEventCallback: ({ commit }, { elementId, eventName }) => {
    commit('removeElementEventCallback', { elementId, eventName });
  }
};

export default {
  ...socketEventActions,
  ...stateActions
};
